import React, { Component } from "react";
import './BulkCmdHistory.css'
import moment from "moment";
import DatePicker from "react-datepicker";
import CommandAPIs from '../../APIs/CommandAPIs'
import downarrow from '../../assets/images/icon/downarrow.png'
import arrowright from '../../assets/images/icon/arrowright.png'
import BulkCommand from "./BulkCommand";
import { JSONToCSVConvertor } from "../../helpers/helperFunctions";
class BulkCmdHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            busy:false,
            expand:false,
            bulkPopup:false,
            detailedFailed: false,
            historyfailed:false,
            startDate: moment(Date.now()).startOf("day").subtract(1, "days").toDate(),
            endDate: moment().toDate(),
            historyData: [],
            cmdDetails: [],
            heads:[
                {key:"totalvehicles", name: "Total Vehicles"},
                {key:"commandtype", name: "Command Type"},
                {key:"username", name: "user Name"},
                {key:"mainusername", name: "Main User Name"},
            ],
            detailsHead: [
                {key:"slno", name: "#"},
                {key:"batteryid", name: "Vehicle No."},
                {key:"cmdtype", name: "Command Type"},
                {key:"cmdstatus", name: "Command  Status"},
                {key:"cmdtime", name: "Command Time"},
            ],
            vehicleList: []

        }
        
    }
    



  handleStartDate = (date) => {
    this.setState({ startDate: date },()=> {});
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date },()=>{});
  };

  closeInfo = () => {
    this.setState({detailedFailed:false})
  }

  changeExpand = (data, index) => {
    if (this.state.selectedIndex === index) {
        // If the same div is clicked again, collapse it
        this.setState({ expand: false, selectedIndex: null, cmdDetails: [] });
    } else {
        let body = { bulkid: data.bulkid };
        CommandAPIs.listAllBulkCmdsDetails(body).then((resp) => {
            let details = resp.map((item, idx) => {
                const latestEntry = [...item.status].sort((a, b) => b.timestamp - a.timestamp)[0];
                return {
                    slno: idx + 1,
                    batteryid: item.batteryid,
                    cmdtype: item.cmd.type,
                    cmdstatus: latestEntry.cmdstatus,
                    cmdtime: moment(latestEntry.timestamp).format("DD-MMM-YYYY hh:mm A")
                };
            });

            this.setState({ cmdDetails: details, expand: true, selectedIndex: index });
        }).catch((e) => {
            this.setState({detailedFailed:true})
        })
    }
};

 downloadCsv= (data,index,details)=>{
    JSONToCSVConvertor(data,details.commandtype+ '_' + moment(Date.now()).format('DD_MM_YYYY HH:mm:ss'),true)
 }
  CreateHistory = (data,index) => {
    return (
        <div key={index} className="row-container">
            <div className="row-full">
                <div  className="row">
                    {this.state.heads.map((head,index2) => {
                        return (
                            <div key={index2} className="cols">
                                <span className="cols-header">{head.name}</span>
                                <span className="cols-value">{data[head.key]}</span>
                            </div>
                        )
                    })}
                </div>
                <span className="arrow-button">
                    <span className="arrow" onClick={()=>{this.downloadCsv(this.state.cmdDetails,index,data)}}>
                      {this.state.expand && index === this.state.selectedIndex ?<i className="fa fa-download"></i>:null }
                    </span>
                    <span className="arrow" onClick={() => {this.changeExpand(data,index)}}>
                        {this.state.expand && index === this.state.selectedIndex ? <img  src={downarrow} /> : !this.state.expand && index === this.state.selectedIndex ? <img src={arrowright} />:<img src={arrowright} />}
                    </span>
                </span>
            </div>
            {this.state.expand && this.state.selectedIndex === index ? <div className="sub-table">
                <div className="header">
                    {this.state.detailsHead.map((head,index) => {
                        return(
                            <span>{head.name}</span>
                        )
                    })}
                </div>
                <div className="sub-table-row">
                    {this.state.cmdDetails.map((cmds,index) => {
                       return(
                            <div className="table-row">
                                {this.state.detailsHead.map((head,index) => {
                                return <span>{cmds[head.key]}</span>
                                
                                })}
                            </div>
                       ) 
                       
                    })}
                </div>
               
                
            </div> :null}
        </div>
    )
  }
  componentDidMount() {
    window.addEventListener("keydown", (e) => {
        if (e.keyCode === 27) {
            this.bulkClose()
        }
    })    
    this.fetchHistory()
    let vehicleList = []
    for(let idx in  window.vehicleMap){
        let obj ={}
        let vehicle =  window.vehicleMap[idx] 
        obj.vehicleno  = vehicle.vehicleno
        obj.id = idx
        vehicleList.push(obj)
    }
    this.setState({vehicleList:vehicleList})
    
  }
  fetchHistory = (date1,date2) => {
    this.setState({busy:true})
    let startDate = null
    let endDate = null
    if(date1 && date2) {
        startDate = moment(date1).unix() * 1000
        endDate = moment(date2).unix() * 1000
    }else {
        startDate = moment(this.state.startDate).unix() * 1000
        endDate = moment(this.state.endDate).unix() * 1000
    }
    let body = {
        starttime:startDate,
        endtime:endDate
    }
    CommandAPIs.listAllBulkcmds(body).then((resp) => {
       
        this.setState({historyData: resp,busy:false})
    }).catch(() => {
        this.setState({busy:false})
    })
  }
  bulkAddChange = () => {
    this.setState({bulkPopup: true})
  }
  bulkClose = () => {
    this.setState({bulkPopup: false})
  }

    render() {
        return (
            <div className="history-container">
                <div className="bulk-button">
                    <span className="add-btn" onClick={() => this.bulkAddChange()}>Bulk Add</span>
                    {this.state.bulkPopup ? <div className="bulk-popup">
                        <BulkCommand vehicleList={this.state.vehicleList} 
                        bulkClose={() => this.bulkClose()} 
                        fetchHistory={ (date1,date2) =>this.fetchHistory(date1,date2)} />

                    </div> : null}
                </div>
                <div className="history-section">
                    <div className="history-head">
                        <div className="history-title">
                            History
                        </div>
                        <div className="history-date">
                            <div className="his-datepicker">
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.startDate}
                                    onChange={(e) => this.handleStartDate(e)}
                                    dateFormat="dd-MMM-yyyy"
                                />
                            </div>
                            <div className="his-datepicker">
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.endDate}
                                    onChange={(e) => this.handleEndDate(e)}
                                    dateFormat="dd-MMM-yyyy"
                                />
                            </div>
                            <div className="ok-btn" onClick={() => this.fetchHistory()}>
                                OK
                            </div>
                        </div>
                    </div>
                    <div className="history-table">
                        {this.state.historyData.length ? this.state.historyData.map((data,index) => {
                            return this.CreateHistory(data,index)
                        }): !this.state.busy ?<div className="no-history">No History Available</div>: null }
                    </div>
                </div>
                {this.state.busy ? <div className="loader-container"><span className="loader"></span> </div>: null}
                {this.state.detailedFailed ? <div className="history-error">
                    <span>Failed to fetch command details!</span><span className="close-btn" onClick={() => this.closeInfo()}>x</span>
                </div> : null}
            </div>
        )
    }
}
export default BulkCmdHistory